window.addEventListener('DOMContentLoaded', () => {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const desktopWrapper = document.querySelector('.section-header');
    const mobileWrapper = document.querySelector('.section-mobile-header');
    const closeBtn = announcementBar?.querySelector('.announcement-bar_closeBtn');
    const utilityBar = announcementBar?.querySelector('.utility-bar');
    const showDays = utilityBar ? parseInt(utilityBar.getAttribute('show-announcement-bar'), 10) : 0;

    const setCookie = (name, value, days) => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${value};${expires};path=/;SameSite=None;Secure`;
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const cookiesArray = document.cookie.split(';');
        for (let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    };

    function updateEl(el, top, pos = 'sticky', trans = 'top 0.15s ease-in-out') {
        if (!el) return;
        el.style.position = pos;
        el.style.top = top;
        el.style.transition = trans;
    }
    function hideEl(el) { updateEl(el, '-200px'); }
    function staticEl(el) { updateEl(el, '', 'static', ''); }


    closeBtn?.addEventListener('click', () => {
        announcementBar?.classList.add("hidden");
        desktopWrapper.style.top = '0';
        mobileWrapper.style.top = '0';
        setCookie('announcementBarClosed', 'true', showDays);
    });

    const isAnnouncementBarClosed = getCookie('announcementBarClosed');

    if (isAnnouncementBarClosed !== 'true') {
        announcementBar?.classList.remove("hidden");
    } else {
        announcementBar?.classList.add("hidden");
        if (desktopWrapper) desktopWrapper.style.top = '0';
        if (mobileWrapper) mobileWrapper.style.top = '0';
    }

    const barHeight = (!isAnnouncementBarClosed && announcementBar) ? announcementBar.offsetHeight + 'px' : '0';

    const dt = desktopWrapper?.getAttribute('data-sticky-type');
    const mt = mobileWrapper?.getAttribute('data-sticky-type');

    if (dt === 'always' || dt === 'on-scroll-up') {
        updateEl(desktopWrapper, barHeight);
    } else {
        staticEl(desktopWrapper);
    }

    if (mt === 'always' || mt === 'on-scroll-up') {
        updateEl(mobileWrapper, barHeight);
    } else {
        staticEl(mobileWrapper);
    }

    let lastY = window.pageYOffset;
    const threshold = 5;
    let scrollTimeout;

    window.addEventListener('scroll', () => {
        const y = window.pageYOffset;
        if (Math.abs(y - lastY) > threshold) {
            if (y > lastY) {
                hideEl(announcementBar);
                hideEl(desktopWrapper);
                hideEl(mobileWrapper);
            } else {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    if (!isAnnouncementBarClosed) updateEl(announcementBar, '0');
                    const newBarHeight = (!isAnnouncementBarClosed && announcementBar)
                        ? announcementBar.offsetHeight + 'px'
                        : '0';
                    if (dt !== 'none') updateEl(desktopWrapper, newBarHeight);
                    if (mt !== 'none') updateEl(mobileWrapper, newBarHeight);
                }, 200);
            }
            lastY = y;
        }
    });
});